const updateDataLayer = (eventPayload: Record<string, unknown>) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
  }
};

export default updateDataLayer;
